interface Comment {
  name: string;
  time: string;
  content: string;
  likes: string;
  replies: string;
}

const comments: Comment[] = [
  {
    name: '资深吃瓜群众',
    time: '2小时前',
    content: '这个网站太强了！之前在其他地方看到的八卦都是断章取义，这里整理得清清楚楚，时间线梳理得明明白白，吃瓜体验满分！尤其是那个每日大赛排名，每天都看。',
    likes: '1.2万',
    replies: '326',
  },
  {
    name: '娱乐圈观察员',
    time: '4小时前',
    content: '关注吃瓜网每日大赛已经有半年了，信息确实比微博热搜还快。而且内容有深度，不是那种标题党，每篇爆料都有理有据。推荐给了身边所有爱八卦的朋友。',
    likes: '8.6千',
    replies: '198',
  },
  {
    name: '理性吃瓜人',
    time: '5小时前',
    content: '说实话现在网上假消息太多了，但吃瓜网每日大赛的「待核实」标签机制真的很好。能看得出来编辑团队是在认真做内容，不是为了流量什么都发。希望能一直保持这个标准。',
    likes: '7.3千',
    replies: '145',
  },
  {
    name: '追剧小达人',
    time: '8小时前',
    content: '综艺翻车那篇太精彩了！把前因后果理得特别清楚，还有现场视频片段。这才是专业吃瓜该有的样子。已收藏，以后就看你们家了。',
    likes: '5.9千',
    replies: '87',
  },
  {
    name: '行业内部人士',
    time: '12小时前',
    content: '作为在娱乐圈工作的人，不得不说吃瓜网每日大赛的很多内容确实很准。有些我们圈内才知道的消息，你们比我们先报道出来，情报能力真的厉害。希望继续保持，但也注意安全。',
    likes: '9.1千',
    replies: '412',
  },
];

const SectionComments = () => (
  <section id="comments" className="py-16 md:py-20 bg-background-100">
    <div className="max-w-[1280px] mx-auto px-4 md:px-6">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">瓜友热评</h2>
        <p className="mt-2 text-sm text-foreground-500">百万瓜友的真实声音</p>
      </div>
      <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-4">
        {comments.map((comment) => (
          <div key={comment.name} className="rounded-xl bg-background-50 border border-background-200/70 p-5 md:p-6">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading font-bold text-sm">
                {comment.name.charAt(0)}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                <p className="text-xs text-foreground-400">{comment.time}</p>
              </div>
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed">{comment.content}</p>
            <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-200/50">
              <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-thumb-up-line"></i>
                {comment.likes}
              </span>
              <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                <i className="ri-chat-1-line"></i>
                {comment.replies} 回复
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default SectionComments;